import { render, staticRenderFns } from "./StoreProductSalesRank.vue?vue&type=template&id=87397200&scoped=true&"
import script from "./StoreProductSalesRank.vue?vue&type=script&lang=js&"
export * from "./StoreProductSalesRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87397200",
  null
  
)

export default component.exports